import React, { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { loginInfo, setUser, setIsGettingUser } from '@/store/slices/user'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import router from './constant/routes'
import { userSelector } from '@/store/slices/user'
import { startAdminChatRealtime, stopAdminChatRealtime } from '@/firebase/chat-realtime'

const App = () => {
  const dispatch = useDispatch()
  const { user } = useSelector(userSelector)

  useEffect(() => {
    const getLoginInfo = async () => {
      try {
        const response = await dispatch(loginInfo()).unwrap()
        dispatch(setIsGettingUser(false))
        dispatch(setUser(response.data))
      } catch(err) {
        dispatch(setIsGettingUser(false))
      }
    }
    getLoginInfo()
  }, [])

  useEffect(() => {
    const canReadChat = user?.grants?.some(grant => (
      grant.resource === 'chat' && grant.actions.includes('read')
    ))
    if (canReadChat) {
      void startAdminChatRealtime()
        .catch(() => undefined)
    } else {
      void stopAdminChatRealtime()
    }
    return () => {
      void stopAdminChatRealtime()
    }
  }, [user])

  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  )
}

export default App
